module.exports = __webpack_public_path__ + "img/point_value_nl.d119e9bf.png";